export default "__VITE_ASSET__DusQjKu5__"